import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faPinterest,
  faTiktok,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCat,
  faCrow,
  faGlobeAmericas as fadGlobeAmericas,
  faDog,
  faStar as fadStar,
  faUserMd as fadUserMd,
  faFrog,
  faHorse,
  faLifeRing,
  faNarwhal,
  faRabbit,
  faTurtle,
  faUnicorn,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faBacteria,
  faBan,
  faBandAid,
  faBars,
  faBooks,
  faCalendarDay,
  faCheck,
  faCircleNotch,
  faCircleUser,
  faClipboardPrescription,
  faCrutch,
  faCut,
  faExclamation,
  faExclamationCircle,
  faEye,
  faFaucet,
  faGiftCard,
  faGlobe,
  faHandHoldingMedical,
  faHatChef,
  faHeartbeat,
  faInfinity,
  faLocationDot,
  faLock,
  faMapMarker,
  faMobile,
  faPhone,
  faPiggyBank,
  faPoop,
  faPrescription,
  faSearch,
  faSkullCrossbones,
  faSparkles,
  faTag,
  faTimes,
  faUserMd,
  faUserNurse,
  faVideo,
  faWeight,
  faWhistle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faBone,
  faMessages,
  faAngleDown as fasAngleDown,
  faStar,
  faVideo as fasVideo,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

export default function registerFontAwesomeSearch() {
  // eslint-disable-next-line vue/multi-word-component-names
  Vue.component('Fa', FontAwesomeIcon);

  library.add({
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faBacteria,
    faBan,
    faBandAid,
    faBars,
    faBone,
    faBooks,
    faCalendarDay,
    faCat,
    faCheck,
    faCircleNotch,
    faCircleUser,
    faClipboardPrescription,
    faCrow,
    faCrutch,
    faCut,
    fadGlobeAmericas,
    faDog,
    fadStar,
    fadUserMd,
    faExclamation,
    faExclamationCircle,
    faEye,
    faFacebook,
    faFaucet,
    faFrog,
    faGiftCard,
    faGlobe,
    faHandHoldingMedical,
    faHatChef,
    faHeartbeat,
    faHorse,
    faInfinity,
    faInstagram,
    faLifeRing,
    faLinkedin,
    faLocationDot,
    faLock,
    faMapMarker,
    faMessages,
    faMobile,
    faNarwhal,
    faPhone,
    faPiggyBank,
    faPinterest,
    faPoop,
    faPrescription,
    faRabbit,
    fasAngleDown,
    faSearch,
    faSkullCrossbones,
    faSparkles,
    faStar,
    fasVideo,
    faTag,
    faTiktok,
    faTimes,
    faTurtle,
    faTwitter,
    faUnicorn,
    faUser,
    faUserMd,
    faUserNurse,
    faVideo,
    faWeight,
    faWhistle,
    faYoutube,
  });
}
